var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5C0 8.58594 8.01562 0.5 18 0.5C27.9141 0.5 36 8.58594 36 18.5C36 28.4844 27.9141 36.5 18 36.5C8.01562 36.5 0 28.4844 0 18.5ZM11.8125 16.8125C10.8281 16.8125 10.125 17.5859 10.125 18.5C10.125 19.4844 10.8281 20.1875 11.8125 20.1875H24.1875C25.1016 20.1875 25.875 19.4844 25.875 18.5C25.875 17.5859 25.1016 16.8125 24.1875 16.8125H11.8125Z",
    fill: "#A8071A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeCircle);
export default __webpack_public_path__ + "static/media/NegativeCircle.eaa9d1c1062fcdb92fea8f6130f6f566.svg";
export { ForwardRef as ReactComponent };